import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const ImageAddressAnimation = () => {
  const containers = document.querySelectorAll(".image-address");
  if (containers.length < 1) {
    return;
  }

  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  if (reduceMotion) return;

  const base = {
    y: 0,
    opacity: 1,
    duration: 1,
    ease: "power2.inOut",
  };
  const applyAnimations = () => {
    containers.forEach((container) => {
      const image = container.querySelectorAll(".image-address__image");
      const upperText = container.querySelectorAll(".upper-text-box");
      const horizontalLine = container.querySelectorAll(".horizontal-line");
      const lowerText = container.querySelectorAll(".lower-text-box");

      if (
        !image.length &&
        !upperText.length &&
        !horizontalLine.length &&
        !lowerText.length
      )
        return;

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container,
          start: "top 80%",
          once: true,
          fastScrollEnd: true,
        },
      });

      if (image.length) {
        tl.to(image, {
          opacity: 1,
          duration: 1,
          ease: "back.out(1.7, 0.5)",
          scale: 1,
        });
      }

      if (horizontalLine.length) {
        tl.to(horizontalLine, { ...base, width: "60%" }, 0.2);
      }

      if (upperText.length) {
        tl.to(upperText, base, 0.6);
      }

      if (lowerText.length) {
        tl.to(lowerText, base, 0.6);
      }
    });
  };
  applyAnimations();
};

export default ImageAddressAnimation;
